module.exports = __webpack_public_path__ + "img/effect.a658efd1.svg";